/** @format */

'use strict';
// Generated by jhipster/controller/genericOverviewWithPaging.ftl

angular
	.module('emsApp')
	.controller('SalesFilterTabController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		SalesFilterFactory,
		FindAllSalesFiltersByQueryParamsFactory,
		NoPagingSalesFilterFactory,
		NoPagingSalesStatusFactory,
		NoPagingUserFactory
	) {
		$scope.salesFilterList = [];
		$scope.predicate = 'id';
		$scope.ascending = false;
		$scope.page = 1;
		// a custom hook could be implemented here to add additional fields: custom/jhipster/controller/overview/additional-fields.ftl

		if ($rootScope.isDefinedAndNotNull($rootScope.pageSizeSalesFilter)) {
			$scope.pageSize = angular.copy($rootScope.pageSizeSalesFilter);
		} else {
			$scope.pageSize = 20;
			// A custom hook for setting page size can be implemented here: custom/jhipster/controller/overview/overview_uses_paging.ftl
			$rootScope.pageSizeSalesFilter = angular.copy($scope.pageSize);
		}

		$scope.goToNewState = function() {
			// this overview is in a tab and mapped by $scope.mappedBy / $scope.mappedById
			$state.go($state.current.name + '.newSalesFilter', { mappedBy: $scope.mappedBy, mappedById: $scope.mappedById });
		};

		$scope.goToEditState = function(salesFilter) {
			// this overview is in a tab and mapped by $scope.mappedBy / $scope.mappedById
			$state.go($state.current.name + '.editSalesFilter', {
				salesFilterId: salesFilter.id,
				mappedBy: $scope.mappedBy,
				mappedById: $scope.mappedById,
			});
		};

		$scope.getSalesFilterList = function() {
			FindAllSalesFiltersByQueryParamsFactory.query(
				{
					salesStatusId: angular.isDefined($scope.salesStatusId) ? $scope.salesStatusId : null,
					userId: angular.isDefined($scope.userId) ? $scope.userId : null,

					page: $scope.page - 1,
					size: $scope.pageSize,
					sort: [$scope.predicate + ',' + ($scope.ascending ? 'asc' : 'desc')],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.salesFilterList = result;
				}
			);
		};
		$scope.loadAll = function() {
			$scope.getSalesFilterList();
		};

		$scope.loadPage = function() {
			$scope.loadAll();
		};

		$scope.singleDelete = function(id) {
			$scope.selectedSalesFilterId = id;
			$('#deleteSalesFilterConfirmationInTab').modal('show');
		};

		$scope.confirmSingleDelete = function() {
			SalesFilterFactory.delete(
				{ id: $scope.selectedSalesFilterId },
				function() {
					$scope.loadAll();
					$('#deleteSalesFilterConfirmationInTab').modal('hide');
				},
				function(error) {
					$('#deleteSalesFilterConfirmationInTab').modal('hide');
					AlertService.error(error.data.message, error.data.params);
				}
			);
		};

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.predicate === itemName) {
				if ($scope.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};
	});
